import * as initialMoment from "moment";
import API from "@irati/utils/services/API";
/*
@todo: This is a hack to get around the problem discussed here:
https://github.com/aurelia/skeleton-navigation/issues/606
Feels like something that could be fixed in our ts setup
*/
// @ts-ignore
var moment = initialMoment.default || initialMoment;
var API_CHECK_URL = "https://api.ipstack.com/check";
var API_KEY = "47345ede62a1dce3b2dbbd143d4ed4fa";
var DEFAULT_TIMEOUT = 30000;
var DEFAULT_CACHE_DURATION = 1800000;
var convertIpstackLocation = function (_a) {
    var latitude = _a.latitude, longitude = _a.longitude, city = _a.city;
    return {
        latLng: {
            lat: latitude,
            lng: longitude
        },
        city: city
    };
};
var cache = {
    timestamp: null,
    data: null
};
var getCacheData = function (cacheDuration) {
    var now = moment();
    var timestamp = cache.timestamp, data = cache.data;
    return new Promise(function (resolve, reject) {
        if (timestamp && data && (now.diff(timestamp) < cacheDuration)) {
            resolve(data);
        }
        else {
            reject();
        }
    });
};
var updateCache = function (data, timestamp) {
    if (timestamp === void 0) { timestamp = moment(); }
    cache.data = data;
    cache.timestamp = timestamp;
};
export var getCurrentPosition = function (timeout, cacheDuration) {
    if (timeout === void 0) { timeout = DEFAULT_TIMEOUT; }
    if (cacheDuration === void 0) { cacheDuration = DEFAULT_CACHE_DURATION; }
    var options = {
        unAuth: true,
        params: {
            access_key: API_KEY
        }
    };
    var timeoutId;
    if (cacheDuration <= 0) {
        updateCache(null, null);
    }
    return getCacheData(cacheDuration)
        .catch(function () {
        return new Promise(function (resolve, reject) {
            timeoutId = setTimeout(function () {
                reject(new Error("geolocation.fallbackPosition.getCurrentPosition.timeoutExceeded"));
            }, timeout);
            API.get(API_CHECK_URL, options)
                .then(function (data) {
                clearTimeout(timeoutId);
                var error = data.data.error;
                if (error) {
                    throw new Error(error.info);
                }
                var ipstackLocation = convertIpstackLocation(data.data);
                var latLng = ipstackLocation.latLng, city = ipstackLocation.city;
                var newData = {
                    latLng: latLng,
                    city: city,
                    isFallback: true
                };
                updateCache(newData);
                resolve(newData);
            }).catch(reject);
        });
    })
        .catch(function (fallbackError) {
        clearTimeout(timeoutId);
        throw fallbackError;
    });
};
